<div class="banner">
	<div class="col-12 pb-5">
		<h1>Thank You!</h1>
	</div>
</div>

<div>
	<iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>

<div *ngIf="tableColumns" class="tabcontent">
	<div *ngIf="meta" class="row">
		<div class="col-9">
			<p>
				<span>You have completed your short code orders, and your short codes are now in Approved status.</span>
				<span>Your Order IDs are: {{orderIds}}.</span>
			</p>
			<p>
				<a class="link" style="cursor: pointer;"
					[routerLink]="['/dashboard',{
						
								outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['multiPaymentReceipt', payment.paymentId ] } } ] } } ]">
					View Receipt</a>
			</p>
			<p>
				<span>You will receive an email notification with a copy of your receipt shortly.</span>
				<span>You can also download your receipt using the link, below.</span>
				<a class="link lg" style="cursor: pointer;" (click)="downloadReceiptPdf()">Download Receipt</a>
			</p>
			<p *ngIf="meta.anyMb">
				Since you have chosen to automatically renew at least one short code into monthly billing upon
				payment of the initial pre-paid term, a billed monthly order has been created and is the latest order for
				those short code(s). The short code(s) will be billed monthly following the completion of the
				pre-paid term.
			</p>
		</div>

		<p-table styleClass="p-datatable-striped" [columns]="tableColumns" [value]="leases" [autoLayout]="true">
			<ng-template pTemplate="header" let-columns>
				<tr>
					<th *ngFor="let col of columns" class="noBorder" [ngClass]="col.field">
						{{col.header}}
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-rowData let-columns="columns">
				<tr>
					<td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field" [ngClass]="col.field">
						<div *ngSwitchDefault>{{ rowData[col.field] }}</div>
						<div *ngSwitchCase="'scId'">
							<a class="link"
								[routerLink]="['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list', {scId: rowData[col.field]}] } }] } }]">{{
								rowData[col.field] }}</a>
						</div>
						<div *ngSwitchCase="'price'">
							{{ rowData[col.field] | currency }}
						</div>
						<div *ngSwitchCase="'addToMonthlyBilling'">
							{{(rowData.applicationType !== 'Renew' && rowData.addToMb) | yesNo:(rowData.applicationType === 'Renew')}}
						</div>
						<div *ngSwitchCase="'autoRenew'">
							{{ rowData.autorenew | autoRenew }}
						</div>
						<div class='text-nowrap' *ngSwitchCase="'discount'">
							<span *ngIf="(rowData.discountAmount !== 0 || (rowData.discountList && rowData.discountList.length > 0) )">
								{{ rowData.discountList | discountSummary }}
								<span *ngIf="rowData.discountAmount">({{rowData.discountAmount | currency }}) </span>
							</span>
						</div>
						<div *ngSwitchCase="'listPrice'">
							{{ rowData.listPrice | currency }}
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
		<div>
			<h5><b>Total:&nbsp;&nbsp;{{ payment.totalPrice | currency }}</b></h5>
		</div>
	</div>
	<div *ngIf="firstLease && billingInfo" class="row mt-3">
		<div class="col-6">
			<h3>CSC Registrant Information</h3>
			<div class="me-4 mb-2">{{ firstLease.firstName }} {{ firstLease.lastName }}</div>
			<div class="me-4 mb-2">
				<div class="truncate" [pTooltip]="firstLease.address1 ? firstLease.address1 : ''" tooltipPosition="top" appShowToolTipIfTruncated>{{
					firstLease.address1 }}</div>
				<div class="truncate" [pTooltip]="firstLease.address2 ? firstLease.address2 : ''" appShowToolTipIfTruncated *ngIf="firstLease.address2">
					{{firstLease.address2 }}
				</div>
				<div class="truncate" [pTooltip]="firstLease.state ? firstLease.city + ', ' + firstLease.state + ' ' + firstLease.zip  : firstLease.city ? firstLease.city : ''"
					tooltipPosition="top" appShowToolTipIfTruncated>{{ firstLease.city }}<span *ngIf="firstLease.state">,</span> {{ firstLease.state
					}} {{
					firstLease.zip }}</div>
				{{ firstLease.country | scrConfig:'country'}}
			</div>
			<div class="me-4 mb-2 truncate" [pTooltip]="firstLease.email  ? firstLease.email  : ''" tooltipPosition="top" appShowToolTipIfTruncated>{{
				firstLease.email }}</div>
			<div class="me-4 mb-2">{{ firstLease.phone | phoneNumber }} <span *ngIf="firstLease.phoneExtension">&nbsp; Ext. {{
					firstLease.phoneExtension
					}}</span></div>
		</div>
		<div class="col-6">
			<h3>Billing & Payment Information</h3>
			<div class="me-4 mb-2">{{ billingInfo.billingFirstName }} {{ billingInfo.billingLastName }}</div>
			<div class="me-4 mb-2">
				<div class="truncate" [pTooltip]="billingInfo.billingAddress1 ? billingInfo.billingAddress1 : ''" tooltipPosition="top" appShowToolTipIfTruncated>{{
					billingInfo.billingAddress1 }}</div>
				<div class="truncate" [pTooltip]="billingInfo ? billingInfo.billingAddress2 : ''" tooltipPosition="top" appShowToolTipIfTruncated *ngIf="billingInfo.billingAddress2">{{
					billingInfo.billingAddress2}}</div>
				<div class="truncate"
					[pTooltip]="billingInfo.billingState ? billingInfo.billingCity + ', ' + billingInfo.billingState + ' ' + billingInfo.billingZip  : billingInfo.billingCity ? billingInfo.billingCity : ''"
					tooltipPosition="top" appShowToolTipIfTruncated>{{ billingInfo.billingCity }}<span *ngIf="billingInfo.billingState">,</span> {{ billingInfo.billingState }}
					{{
						billingInfo.billingZip }}</div>
				{{ billingInfo.billingCountry | scrConfig:'country'}}
			</div>
			<div class="me-4 mb-2 truncate" [pTooltip]="billingInfo.billingEmail ? billingInfo.billingEmail : ''" tooltipPosition="top" appShowToolTipIfTruncated>{{
				billingInfo.billingEmail }}</div>
			<div class="me-4 mb-2">{{ billingInfo.billingPhone | phoneNumber }}<span *ngIf="billingInfo.billingPhoneExtension">&nbsp;Ext. {{ billingInfo.billingPhoneExtension
					}}</span></div>
		</div>
	</div>

	<div class="row mt-2" *ngIf="availableCredit !== null && availableCredit !== undefined">
		<div class="col-12">
			<h5>Available Account Credit: {{availableCredit | currency}}</h5>
		</div>
	</div>

</div>
